import React from 'react';
import WelcomeBanner from '../mosaic/partials/dashboard/WelcomeBanner.jsx';
import DashboardAvatars from '../mosaic/partials/dashboard/DashboardAvatars.jsx';
import FilterButton from '../mosaic/components/DropdownFilter.jsx';
import Datepicker from '../mosaic/components/Datepicker.jsx';
import DashboardCard01 from '../mosaic/partials/dashboard/DashboardCard01.jsx';
import DashboardCard02 from '../mosaic/partials/dashboard/DashboardCard02.jsx';
import DashboardCard03 from '../mosaic/partials/dashboard/DashboardCard03.jsx';
import DashboardCard04 from '../mosaic/partials/dashboard/DashboardCard04.jsx';
import DashboardCard05 from '../mosaic/partials/dashboard/DashboardCard05.jsx';
import DashboardCard06 from '../mosaic/partials/dashboard/DashboardCard06.jsx';
import DashboardCard07 from '../mosaic/partials/dashboard/DashboardCard07.jsx';
import DashboardCard08 from '../mosaic/partials/dashboard/DashboardCard08.jsx';
import DashboardCard09 from '../mosaic/partials/dashboard/DashboardCard09.jsx';
import DashboardCard10 from '../mosaic/partials/dashboard/DashboardCard10.jsx';
import DashboardCard11 from '../mosaic/partials/dashboard/DashboardCard11.jsx';
import WideSecureLayout from "../layout/WideSecureLayout.jsx";
import Spinner from "../components/Spinner.jsx";
import NoProjectSelected from "./project/NoProjectSelected.jsx";

function NoProjectScreen() {
    return (
        <WideSecureLayout title="Dashboard">
            <NoProjectSelected/>
        </WideSecureLayout>
    );
}

export default NoProjectScreen;
